import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { ExternalDocument } from '../types/ExternalDocument';

export const listExternalDocuments = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<ExternalDocument>> =>
  apiFetch('/external-documents?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listExternalDocumentsAll = (sort?: string, query?: string): Promise<ExternalDocument[]> =>
  apiFetch('/external-documents/all' + (sort ? '?sort=' + sort : '') + (query ? (sort ? '&' : '?') + query : ''));
export const listExternalDocumentsForInspector = (
  params?: { search?: string; documentType?: string; page?: number; size?: number; sort?: string },
): Promise<Page<ExternalDocument> | ExternalDocument[]> => {
  const qs = new URLSearchParams();
  if (typeof params?.page === 'number' && Number.isFinite(params.page)) {
    qs.set('page', String(params.page));
  }
  if (typeof params?.size === 'number' && Number.isFinite(params.size)) {
    qs.set('size', String(params.size));
  }
  if (params?.sort && params.sort.trim()) {
    qs.set('sort', params.sort.trim());
  }
  if (params?.search && params.search.trim()) {
    qs.set('search', params.search.trim());
  }
  if (params?.documentType && params.documentType.trim()) {
    qs.set('documentType', params.documentType.trim());
  }
  const queryString = qs.toString();
  return apiFetch('/external-documents/me/inspector' + (queryString ? `?${queryString}` : ''));
};
export const getExternalDocument = (id: number): Promise<ExternalDocument> => apiFetch('/external-documents/' + id);
export const createExternalDocument = (data: any): Promise<ExternalDocument> =>
  apiFetch('/external-documents', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateExternalDocument = (id: number, data: any): Promise<ExternalDocument> =>
  apiFetch('/external-documents/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteExternalDocument = (id: number): Promise<void> =>
  apiFetch('/external-documents/' + id, { method: 'DELETE' });
